/** @jsxImportSource @emotion/react */
import { ButtonIcon } from "@coreai/component-library";
import React, { useState } from "react";
import { css, useTheme } from "@emotion/react";
import EditProjectDialog from "./EditProjectDialog";

interface EditProjectProps {
  project: any;
  onDelete: (analysisId: string) => void;
  onEdit: (projectId: string, updatedProject: any) => void;
  onDialogOpen: (projectId: string) => void;
  onDialogClose: () => void;

}

export default function EditProject(props: Readonly<EditProjectProps>) {
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const theme = useTheme();

  const onDelete = (event: React.MouseEvent) => {
    event.stopPropagation();
    props.onDelete(props.project.id);
  };

  const onEdit = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowAlertDialog(true);
    props.onDialogOpen(props.project.id);
  };

  const onCloseDialog = () => {
    setShowAlertDialog(false);
    props.onDialogClose();
  };

  const buttonStyle = () => css`
    color: ${theme.colors.primary};
    &:hover {
      border-color: ${theme.colors.white};
      background-color: ${theme.colors.white};
      color: ${theme.colors.primary};
    }
  `;

  return (
    <div style={{ display: "flex" }}>
      <ButtonIcon
        variant={"secondary"}
        size="sm"
        icon={"edit-01"}
        onClick={onEdit}
        css={buttonStyle}
      />
      <ButtonIcon
        variant={"secondary"}
        size="sm"
        icon={"trash"}
        onClick={onDelete}
        css={buttonStyle}
      />
     {showAlertDialog &&  <EditProjectDialog
        project={props.project}
        open={showAlertDialog}
        onClose={onCloseDialog}
        onEdit={props.onEdit}
      />
     }
    </div>
  );
}
